import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const filter = {
	StateId: null as number | null,
	Description: null as string | null,
	Code: null as string | null,
	OrganizationId: null as number | null,
	IsVirtual: null as number | null,
};


export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		StateId: [],
		OrganizationId: [],
	},
	filter,
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
